"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOption = void 0;
const isOption = (input) => {
    if (input === null || input === undefined)
        return false;
    return ((typeof input === 'object' &&
        input !== null &&
        '_tag' in input &&
        input._tag !== undefined &&
        input._tag === 'None') ||
        input._tag === 'Some');
};
exports.isOption = isOption;
